import React, { useCallback, useEffect, useState } from "react";
import { DispatchTransactionEvent } from "../events/events";
import {
  SUSPENDED, ShowError,  
  JSON_KEY_MESSAGE_TYPE, EVENT_TOPIC_FOR_TRANSACTION_SERVER, JSON_KEY_DESCRIPTION,
  JSON_KEY_SUBMITTER, JSON_KEY_STATUS,
  ITEM_STATUS, ITEM_CREATE, ITEM_MODIFY, EVENT_TYPE_EXCHANGE_STATUS, StatusSimpleOptions,
  EVENT_TYPE_EXCHANGE_MODIFY, EVENT_TYPE_EXCHANGE_CREATE, JSON_KEY_EXCHANGE, NO,
  JSON_KEY_WITHDRAW_ALL_ORDERS,
  SUSPEND,
  ConvertStatusFromNameToId,
  ConvertStatus,
  STATUS_ACTIVE,
  ConfirmConfirmCancelAndSubmit,
  ITEM_CANCEL_ALL_ORDERS,
  EVENT_TYPE_EXCHANGE_CANCEL_ALL_ORDERS,
  DROPDOWN_LIST_NONE,
} from "../../common/common";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "../tabs/tabs.css";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { selectTSUserId } from "../../redux/globalsSlice";
import { MSGTYPE_EXCHANGE_CANCEL_ALL_ORDERS, MSGTYPE_EXCHANGE_CHANGE_STATUS, MSGTYPE_EXCHANGE_CREATE, MSGTYPE_EXCHANGE_MODIFY, } from "../../common/msg_types";
import { RenderDropdown, InputField } from "../../common/utilies";
import { yesNoOptions } from "../../common/convert_functions";

const ExchangesAdminForm = ({ rowData, onClose, exchangeOptions }) => {
   const userId = useSelector(selectTSUserId);
   const [selectedTabIndex, setSelectedTabIndex] = useState(0);

   // Form handling
   const {
      handleSubmit,
   } = useForm({});

   // tab1
   const [code, setCode] = useState(rowData?.code ?? '');
   const [status, setStatus] = useState(rowData?.status ? ConvertStatusFromNameToId(rowData.status) : SUSPEND);
   const [withdrawAllOrders, setWithdrawAllOrders] = useState(NO);
   

   // tab 2 & 3
   const [description, setDescription] = useState(rowData?.description ?? '');

   const handleCancel = () => {
      if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
      }
      onClose(); // your modal close function
   };

   const onExchangeDropDownChange = useCallback((e) => setCode(e.target.value), [setCode]);
   const onStatusDropDownChange = useCallback((e) => setStatus(e.target.value), [setStatus]);
   const onYesNoDropDownChange = useCallback((e) => {setWithdrawAllOrders(e.target.value)}, [setWithdrawAllOrders]);
   

   const onExchangeModifyDropDownChange = (e) => {
      setCode(e.target.value);
      setDescription('');
      setStatus(SUSPENDED);
   };

   // const ConfirmAndSubmit = async ({ title, text, item }) => {
   //    const confirmed = await confirmationDialog({ title, text });
   //    if (confirmed) handleStatusConfirmationSubmit(item);
   // };

   const handleStatusConfirmationSubmit = (submitItem) => {
      const base = {
         [JSON_KEY_SUBMITTER]: userId,
         [JSON_KEY_EXCHANGE]: code,
      };

      switch (submitItem) {
         case ITEM_STATUS:
            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               EVENT_TYPE_EXCHANGE_STATUS,
               {
                  ...base,
                  [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_EXCHANGE_CHANGE_STATUS,
                  [JSON_KEY_STATUS]: status,
                  [JSON_KEY_WITHDRAW_ALL_ORDERS]: withdrawAllOrders,
                  
               }
            );
            break;

         case ITEM_CANCEL_ALL_ORDERS:
            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               EVENT_TYPE_EXCHANGE_CANCEL_ALL_ORDERS,
               {
                  ...base,
                  [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_EXCHANGE_CANCEL_ALL_ORDERS,                  
               }
            );
            break;

         case ITEM_CREATE:
            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               EVENT_TYPE_EXCHANGE_CREATE,
               {
                  ...base,
                  [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_EXCHANGE_CREATE,
                  [JSON_KEY_DESCRIPTION]: description,
                  [JSON_KEY_STATUS]: status,
               }
            );
            break;

         case ITEM_MODIFY:
            DispatchTransactionEvent(
               EVENT_TOPIC_FOR_TRANSACTION_SERVER,
               EVENT_TYPE_EXCHANGE_MODIFY,
               {
                  ...base,
                  [JSON_KEY_MESSAGE_TYPE]: MSGTYPE_EXCHANGE_MODIFY,
                  [JSON_KEY_DESCRIPTION]: description,
                  [JSON_KEY_STATUS]: status,
                  [JSON_KEY_WITHDRAW_ALL_ORDERS]: withdrawAllOrders,
               }
            );
            break;

         default:
            console.log("ExchangesAdminForm unknown submit item");
      }
   };

   const ValidateFields = () => {
      if (!code) return "Code is missing";
      if (code === DROPDOWN_LIST_NONE) return "Code is missing";
      if (!description) return "Description is missing";
      if (!status) return "Status is missing";
      return null;
   };

   const handleStatusSubmit = () => {
      const error = ValidateFields();
      if (error) return ShowError(error);

      ConfirmConfirmCancelAndSubmit({
         title: "Exchange Status Change",
         text: `Setting exchange ${code} to ${ConvertStatus(status)}`,
         item: ITEM_STATUS,
         cancel_all: withdrawAllOrders,
         onSubmit: handleStatusConfirmationSubmit,
      });

      onClose(); // your modal close function
   };

   const handleCancelAllOrdersSubmit = () => {
      const error = ValidateFields();
      if (error) return ShowError(error);
      if (withdrawAllOrders === NO) return ShowError("Cancel All Orders must be YES");

      ConfirmConfirmCancelAndSubmit({
         title: "Exchange Cancel All Orders",
         text: `Do you want to cancel all orders on the Exchange ${code}`,
         item: ITEM_CANCEL_ALL_ORDERS,
         cancel_all: withdrawAllOrders,
         onSubmit: handleStatusConfirmationSubmit,
      });

      // ConfirmAndSubmit({
      //    title: "Exchange Cancel All Orders",
      //    text: `Do you want to cancel all orders on the Exchange ${code}`,
      //    item: ITEM_CANCEL_ALL_ORDERS,
      // });

      onClose(); // your modal close function
   };

   const handleCreateSubmit = () => {
      const error = ValidateFields();
      if (error) return ShowError(error);

      ConfirmConfirmCancelAndSubmit({
         title: "Create Exchange",
         text: `Creating new exchange: ${code}`,
         item: ITEM_CREATE,
         cancel_all: withdrawAllOrders,
         onSubmit: handleStatusConfirmationSubmit,
      });

      // ConfirmAndSubmit({
      //    title: "Create Exchange",
      //    text: `Creating new exchange: ${code}`,
      //    item: ITEM_CREATE,
      // });

      onClose(); // your modal close function
   };

   const handleModifySubmit = () => {
      const error = ValidateFields();
      if (error) return ShowError(error);

      ConfirmConfirmCancelAndSubmit({
         title: "Modify Exchange",
         text: `Modifying exchange: ${code}`,
         item: ITEM_MODIFY,
         cancel_all: withdrawAllOrders,
         onSubmit: handleStatusConfirmationSubmit,
      });

      // ConfirmAndSubmit({
      //    title: "Modify Exchange",
      //    text: `Modifying exchange: ${code}`,
      //    item: ITEM_MODIFY,
      // });

      onClose(); // your modal close function
   };

   useEffect(() => {
      if (!rowData) return;
         setCode(rowData.code || '');
         setDescription(rowData.descr || '');
         setStatus(rowData?.status ? ConvertStatusFromNameToId(rowData.status) : SUSPEND);
   }, [rowData]);

   useEffect(() => {
      if (selectedTabIndex === 2) {
         setStatus(SUSPENDED);
      }
   }, [selectedTabIndex]);

   return (
      <div className="admin-form">
         <div className="admin-tabs">
         <h2 className="center-heading">Exchange Administration</h2>
         <Tabs selectedIndex={selectedTabIndex} onSelect={setSelectedTabIndex} forceRenderTabPanel={true} className="admin-tabs" >
            <TabList>
               <Tab>Change Status</Tab>
               <Tab>Modify Exchange</Tab>
               <Tab>Create Exchange</Tab>
               <Tab>Cancel All Orders</Tab>
            </TabList>

            {/* Tab 1: Change Status */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleStatusSubmit)}>
               <div className="top">
                  {RenderDropdown("Code", code, exchangeOptions, onExchangeDropDownChange)}
               </div>
               <div className="top">
                  {RenderDropdown("Status", status, StatusSimpleOptions, onStatusDropDownChange)}
               </div>
               <div className="top">
               {RenderDropdown(
                  "Cancel All Orders",
                  status === STATUS_ACTIVE ? NO : withdrawAllOrders, // force NO if Active
                  yesNoOptions,
                  status === STATUS_ACTIVE ? () => {} : onYesNoDropDownChange, // ignore changes if Active
                  status === STATUS_ACTIVE // disable dropdown if Active
               )}
               </div>
               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>

            {/* Tab 2: Modify Exchange */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleModifySubmit)}>
               <div className="top">
                  {RenderDropdown("Code", code, exchangeOptions, onExchangeModifyDropDownChange)}
               </div>
               <div>
                  <InputField label="Description" value={description} onChange={setDescription} />
               </div>
               {/* <div className="top">
                  {RenderDropdown("Status", status, StatusSimpleOptions, onStatusDropDownChange)}
               </div>
               <div className="top">
                  {RenderDropdown("Withdraw All Orders", withdrawAllOrders, yesNoOptions, onYesNoDropDownChange)}
               </div>                */}
               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>            
            
            {/* Tab 3: Create Exchange */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleCreateSubmit)}>
               <div>
                  <InputField label="Code" value={code} onChange={setCode} />
               </div>

               <div>
                  <InputField label="Description" value={description} onChange={setDescription} />
               </div>

               {/*
               <div className="top">
                  {RenderDropdown("Status", status, StatusSimpleOptions, onStatusDropDownChange, true)}
               </div>
               */}

               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>

            {/* Tab 4: Cancel All Orders */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleCancelAllOrdersSubmit)}>
               <div className="top">
                  {RenderDropdown("Code", code, exchangeOptions, onExchangeDropDownChange)}
               </div>

               <div className="top">
                  {RenderDropdown("Cancel All Orders", withdrawAllOrders, yesNoOptions, onYesNoDropDownChange)}
               </div>  
               
               {/* <div className="top">
                  {RenderDropdown("Status", status, StatusSimpleOptions, onStatusDropDownChange)}
               </div>  */}

               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>

         </Tabs>
         </div>
      </div>
   );
};

export default ExchangesAdminForm;
